'use strict';

require('../../style/index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/icon/style/css.js
// module id = 29
// module chunks = 0